import { useEffect } from "react";
import Lenis from "lenis";
import { Nav } from "@/site/Nav";
import { Hero } from "@/site/Hero";
import { Marquee } from "@/site/Marquee";
import { Story } from "@/site/Story";
import { WelcomeBanner } from "@/site/WelcomeBanner";
import { VideoTour } from "@/site/VideoTour";
import { Features } from "@/site/Features";
import { Spaces } from "@/site/Spaces";
import { Breakfast } from "@/site/Breakfast";
import { Karens } from "@/site/Karens";
import { Location } from "@/site/Location";
import { Reviews } from "@/site/Reviews";
import { Host } from "@/site/Host";
import { BookingCTA } from "@/site/BookingCTA";
import { Footer } from "@/site/Footer";
import { LightboxProvider } from "@/site/Lightbox";

const MARQUEE_ITEMS = [
  "The Old Pub Cellar",
  "Historic Luxury",
  "Chirton, Wiltshire",
  "Gym & Sauna",
  "9.8 Guest Rating",
];

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);

    const onClick = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const id = a.getAttribute("href");
      if (id.length < 2) return;
      const el = document.querySelector(id);
      if (el) {
        e.preventDefault();
        lenis.scrollTo(el, { offset: -80 });
      }
    };
    document.addEventListener("click", onClick);

    return () => {
      cancelAnimationFrame(raf);
      document.removeEventListener("click", onClick);
      lenis.destroy();
    };
  }, []);

  return (
    <LightboxProvider>
    <div className="App relative bg-bg min-h-screen">
      <div className="noise-overlay pointer-events-none fixed inset-0 z-50 opacity-[0.035] mix-blend-overlay" />
      <Nav />
      <main>
        <Hero />
        <Marquee items={MARQUEE_ITEMS} testId="hero-marquee" />
        <Story />
        <WelcomeBanner />
        <VideoTour />
        <Features />
        <Spaces />
        <Breakfast />
        <Karens />
        <Location />
        <Reviews />
        <Host />
        <BookingCTA />
      </main>
      <Footer />
    </div>
    </LightboxProvider>
  );
}

export default App;
